import { useRef } from "react"
import { LOADING, OK, type DataStatus } from "helpers/data-statuses"
import { buildStableCacheKey } from "helpers/intraday-query-key"

export function useIntradayEnhancement<T>(
  data: T | null,
  status: DataStatus,
  queryKeys: unknown[][],
): { effectiveData: T | null, effectiveStatus: DataStatus } {
  const stableKey = buildStableCacheKey(queryKeys)
  const cacheRef = useRef<{ key: string, data: T } | null>(null)

  if (status === OK && data !== null) {
    cacheRef.current = { key: stableKey, data }
  }

  const cachedData = cacheRef.current?.key === stableKey ? cacheRef.current.data : null
  const effectiveData = status === LOADING && cachedData !== null ? cachedData : data
  const effectiveStatus = status === LOADING && cachedData !== null ? OK : status

  return { effectiveData, effectiveStatus }
}
